import { render, staticRenderFns } from "./ATRP_SettingsWindow.vue?vue&type=template&id=0fc5152e&scoped=true"
import script from "./ATRP_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./ATRP_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5152e",
  null
  
)

export default component.exports